/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {getters} from '@/store/modules/game/getters';
import {actions} from '@/store/modules/game/actions';
import {mutations} from '@/store/modules/game/mutations';
import {GameState, GameStateInterface} from '@/store/modules/game/types';

/**
 * The game store module.
 * This module is imported by vuex as a representation of the game specific data such as species and favourites.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const state: GameStateInterface = new GameState();

const namespaced: boolean = true;

export const gameModule: Module<GameStateInterface, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
